import React, { useState, useEffect } from 'react';
import {
  requestNotificationPermission,
  unsubscribeFromPushNotifications,
  checkSubscriptionStatus,
} from '../utils/pushNotifications';
import './NotificationBell.css';

const NotificationBell = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  useEffect(() => {
    // Check subscription status on mount
    const checkStatus = async () => {
      try {
        const subscribed = await checkSubscriptionStatus();
        console.log('[NotificationBell] Subscription status:', subscribed);
        setIsSubscribed(subscribed);
      } catch (error) {
        console.error('[NotificationBell] Status check error:', error);
        setIsSubscribed(false);
      }
    };

    // Check immediately
    checkStatus();

    // Also check again after a short delay (helps on page reload)
    const timer = setTimeout(checkStatus, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleToggle = () => {
    if (isSubscribed) {
      // Show unsubscribe modal
      handleUnsubscribe();
    } else {
      // Show permission modal
      setShowPermissionModal(true);
    }
  };

  const handleUnsubscribe = async () => {
    setIsLoading(true);
    try {
      const success = await unsubscribeFromPushNotifications();
      if (success) {
        setIsSubscribed(false);
        setShowToast({
          type: 'success',
          message: 'सूचनाएं बंद हो गईं',
        });
      } else {
        setShowToast({
          type: 'error',
          message: 'अनसब्सक्राइब विफल',
        });
      }
    } catch (error) {
      console.error('[NotificationBell] Unsubscribe error:', error);
      setShowToast({
        type: 'error',
        message: 'कुछ गलत हुआ',
      });
    } finally {
      setIsLoading(false);
      setTimeout(() => setShowToast(null), 3000);
    }
  };

  const handlePermissionConfirm = async () => {
    setShowPermissionModal(false);
    setIsLoading(true);
    try {
      const success = await requestNotificationPermission();
      if (success) {
        setIsSubscribed(true);
        localStorage.removeItem('notificationNeverAsk');
        setShowToast({
          type: 'success',
          message: 'सूचनाएं सक्षम हो गईं!',
        });
      } else {
        setShowToast({
          type: 'error',
          message: 'सूचनाओं को सक्षम करने में विफल',
        });
      }
    } catch (error) {
      console.error('[NotificationBell] Permission error:', error);
      setShowToast({
        type: 'error',
        message: 'कुछ गलत हुआ',
      });
    } finally {
      setIsLoading(false);
      setTimeout(() => setShowToast(null), 3000);
    }
  };

  const handlePermissionCancel = () => {
    setShowPermissionModal(false);
  };

  return (
    <>
      <button
        className={`notification-bell ${isSubscribed ? 'active' : ''}`}
        onClick={handleToggle}
        disabled={isLoading}
        title={isSubscribed ? 'सूचनाएं सक्षम हैं' : 'सूचनाएं सक्षम करें'}
      >
        <span className="bell-icon">
          {isLoading ? '⏳' : isSubscribed ? '🔔' : '🔕'}
        </span>
        <span className="bell-text">
          {isSubscribed ? 'सब्सक्राइब्ड' : 'सदस्यता लें'}
        </span>
      </button>

      {showToast && (
        <div className={`notification-toast ${showToast.type}`}>
          {showToast.message}
        </div>
      )}

      {showPermissionModal && (
        <div className="permission-modal-overlay">
          <div className="permission-modal">
            <div className="permission-modal-header">
              <h2>🔔 सूचनाएं सक्षम करें</h2>
              <button
                className="modal-close"
                onClick={handlePermissionCancel}
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            <div className="permission-modal-body">
              <p className="permission-description">
                नई खबर, फोटो गैलरी और इवेंट्स के लिए तुरंत सूचनाएं प्राप्त करें।
              </p>
              <ul className="permission-benefits">
                <li>✓ तुरंत खबरें अपने डिवाइस पर पाएं</li>
                <li>✓ महत्वपूर्ण अपडेट्स मिस न करें</li>
                <li>✓ आसानी से बंद कर सकते हैं</li>
              </ul>
            </div>

            <div className="permission-modal-footer">
              <button
                className="btn-cancel"
                onClick={handlePermissionCancel}
                disabled={isLoading}
              >
                अभी नहीं
              </button>
              <button
                className="btn-allow"
                onClick={handlePermissionConfirm}
                disabled={isLoading}
              >
                {isLoading ? 'लोड हो रहा है...' : 'सक्षम करें'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationBell;
